export default function (context, {name, value}) {
    let data = {};
    switch (name) {
        case 'Contragent':
            context.commit('set', {
                ContragentId: value.value,
                ContragentName: value.label,
                ContragentType: value.type,
            });
            switch (value.type) {
                case 'partner':
                    context.dispatch('get_legal', {PartnerId: value.value});
                    break;
            }
            break;
        default:
            data[name] = value;
            context.commit('set', data);
    }
}